import "./StoryDetailPage.scss";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getStory } from "../../utils/apiUtils";
import { FaHeart } from "react-icons/fa";

function StoryDetailPage() {
  const { id } = useParams();
  const [story, setStory] = useState(null);

  useEffect(() => {
    const fetchStory = async () => {
      try {
        const response = await getStory(id);
        setStory(response.data);
      } catch (error) {
        console.error("Error fetching story details:", error);
      }
    };

    fetchStory();
  }, [id]);

  if (!story) {
    return <p>Loading...</p>;
  }

  return (
    <div className="story-detail">
      <div className="story-detail__content">
        <h1 className="story-detail__title">{story.title}</h1>
        <p className="story-detail__name">By: {story.name}</p>
        <p className="story-detail__description">{story.description}</p>

        <div className="storiesList__likes">
          <FaHeart className="storiesList__heart" />
          {story.likes.length}
        </div>
        <div>{story.comments}</div>
        <p className="story-detail__date">
          Date submitted: {new Date(story.timestamp).toLocaleDateString()}
        </p>
        <Link to={"/stories"} className="story-detail__return">
          BACK TO GRIEFFITI WALL
        </Link>
      </div>
    </div>
  );
}
export default StoryDetailPage;
